const CLOSE_ICON_SIZE = {
  small: {
    size: 16
  },
  middle: {
    size: 24
  },
  large: {
    size: 30
  }
};
export {
  CLOSE_ICON_SIZE
};
//# sourceMappingURL=Drawer.constants.js.map
